import { useState, type ReactNode } from 'react';

import { AttestationModal } from '@/pages/login/AttestationModal';

import { hasAttestedThisSession, markAttested } from './attestationSession';
import { useAuth } from './useAuth';

/**
 * Holds every protected route behind the login attestation (PLA-1110).
 *
 * Renders only the blocking modal until this tab has recorded an attestation
 * for the signed-in account, so no dashboard query fires before the user has
 * agreed. A same-tab refresh after accepting passes straight through; a new
 * tab, a new login, or a different account prompts again.
 */
export function AttestationGate({ children }: { children: ReactNode }) {
  const { user, signOut } = useAuth();
  const accountId = user?.homeAccountId ?? '';
  const [attested, setAttested] = useState(() => hasAttestedThisSession(accountId));

  if (!attested) {
    return (
      <AttestationModal
        onAttested={() => {
          markAttested(accountId);
          setAttested(true);
        }}
        onSignOut={() => void signOut()}
      />
    );
  }

  return <>{children}</>;
}
